import React, { useState } from 'react'; // Aggiunto useState
import { Save, FolderOpen, LayoutDashboard } from 'lucide-react';
import MenuButton from '../../../common/MenuButton/MenuButton';
import useGeoData from '../../../store/useGeoData';
import ExportMapLibreStyleDialog, { useMapLibreExportData } from '../../export/components/dialogs/ExportMapLibreStyleDialog';
import { selectAllAppLayers } from '../../../store/layerSlice';
import { useShallow } from 'zustand/react/shallow';

interface ProjectActionsProps {
  onOpenSaveDialog: () => void;
  onLoadProjectClick: () => void;
}

const ProjectActions: React.FC<ProjectActionsProps> = ({
  onOpenSaveDialog,
  onLoadProjectClick
}) => {
  const [isExportDialogOpen, setIsExportDialogOpen] = useState(false);

  // Utilizza l'hook per ottenere i dati preparati
  const {
    applicationLayers,
    applicationSources,
    applicationLayerStyles,
    mapView: hookMapView // Rinomina per evitare collisione con currentMapView se fosse ancora usato
  } = useMapLibreExportData();

  // Recupera tutti i layer per la prop 'availableLayers' del dialog
  // Questo è separato dalla logica di preparazione dati dell'hook
  const allLayersForDialog = useGeoData(useShallow(selectAllAppLayers)) || [];

  const handleExportMapLibreStyleClick = () => {
    setIsExportDialogOpen(true);
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-s)', width: '100%' }}>
        {/* --- Bottone Salva Progetto --- */}
      <MenuButton
        onClick={onOpenSaveDialog}
        icon={<Save size={20} />}
        className="w-full"
      >
        Save Session State
      </MenuButton>

      {/* --- Bottone Carica Progetto --- */}
      <MenuButton
        onClick={onLoadProjectClick}
        icon={<FolderOpen size={20} />}
        className="w-full"
      >
        Load Session State
      </MenuButton>

      {/* --- Bottone Esporta Stile MapLibre --- */}
      <MenuButton
        onClick={handleExportMapLibreStyleClick}
        icon={<LayoutDashboard size={20} />}
        className="w-full"
      >
        Export MapLibre Style
      </MenuButton>

    </div>
      {isExportDialogOpen && (
        <ExportMapLibreStyleDialog
          isOpen={isExportDialogOpen}
          onClose={() => setIsExportDialogOpen(false)}
          currentMapView={hookMapView} // Usa i dati mapView dall'hook
          availableLayers={allLayersForDialog.map(layer => ({ id: layer.id, name: layer.name || layer.id }))}
          applicationLayers={applicationLayers} // Usa i dati dall'hook
          applicationSources={applicationSources} // Usa i dati dall'hook
          applicationLayerStyles={applicationLayerStyles} // Usa i dati dall'hook
        />
      )}
    </>
  );
};

export default ProjectActions;